module.exports = __webpack_public_path__ + "static/media/leafly_logo.50d06630.png";